export default ((window, document, undefined) => {

  'use strict';

  window.FileInput = function() {    
    function update( event ) {
      const input = event.target.closest( 'input[data-file-input]' );

      if (input) {
        const parent = input.parentElement;
        const files = input.files;
  
        if (files.length) {
          const div = document.querySelector('.input--file__file-list') || document.createElement('div');
          div.innerHTML = '';
          div.className = 'input--file__file-list';
  
          Array.from(files).forEach(file => {
            const p = document.createElement('p');
            p.innerHTML = file.name;
            div.appendChild(p);
          });
    
          parent.insertBefore( div, parent.firstChild );
        }
      }
    }

    return {
      init: (() => {
        window.addEventListener('DOMContentLoaded', () => {
          document.addEventListener( 'change', update ); 
        });
      })()
    };
  };

  FileInput();

})( window, document );
